module.exports = __webpack_public_path__ + "static/media/md-nutrition.189ce36c.svg";